import { Check, Loader2, ShieldCheck } from "lucide-react";
import PropTypes from "prop-types";

// Shown while the last step is being handed to review. The wizard is gone by
// then, so this stands in for it rather than letting the page fall back to a
// bare spinner that says nothing about what is happening.
const KycVerifying = ({ steps }) => (
    <div className="p-6">
        <div className="mx-auto max-w-md rounded-xl border border-gray-200 bg-white p-10 text-center shadow-sm">
            <div className="relative mx-auto flex h-14 w-14 items-center justify-center">
                <span className="absolute h-14 w-14 animate-ping rounded-full bg-primary/20" />
                <span className="absolute h-14 w-14 rounded-full bg-primary/10" />
                <ShieldCheck className="relative h-7 w-7 text-primary" />
            </div>

            <h2 className="mt-4 text-xl font-semibold text-gray-900">Verifying your details</h2>
            <p className="mt-1 text-sm text-muted">Hang tight — we&apos;re sending your documents for review.</p>

            <ul className="mt-6 space-y-2 text-left">
                {steps.map((label) => (
                    <li key={label} className="flex items-center gap-2.5 rounded-lg border border-gray-100 bg-gray-50 px-3.5 py-2.5">
                        <span className="grid h-5 w-5 shrink-0 place-items-center rounded-full bg-success text-white">
                            <Check className="h-3 w-3" strokeWidth={3} />
                        </span>
                        <span className="text-sm text-gray-700">{label} saved</span>
                    </li>
                ))}
                <li className="flex items-center gap-2.5 rounded-lg border border-primary/20 bg-primary/5 px-3.5 py-2.5">
                    <Loader2 className="h-5 w-5 shrink-0 animate-spin text-primary" />
                    <span className="text-sm font-medium text-gray-900">Submitting for verification</span>
                </li>
            </ul>

            <p className="mt-5 text-xs text-muted">Please don&apos;t close this tab.</p>
        </div>
    </div>
);

KycVerifying.propTypes = {
    steps: PropTypes.array
};

KycVerifying.defaultProps = {
    steps: []
};

export default KycVerifying;
